import React, { useEffect, useRef, useState } from 'react';
import '../../../output.scss';
import Language from '../../../../i18n/Language';
const t = Language;

const AIOutputStream = ({
  id,
  contentSegments,
  customClass,
  wordText,
  wordNum,
  onEnd,
}) => {
  const currentIndexRef = useRef(-1);
  const timeoutsRef = useRef([]);
  const maxHeightRef = useRef(0);
  const [visibleIndexes, setVisibleIndexes] = useState([]);
  const [viewTextArray, setViewTextArray] = useState([]);
  // 安全设置定时器
  const safeSetTimeout = (fn, delay) => {
    const timeoutId = setTimeout(fn, delay);
    timeoutsRef.current.push(timeoutId);
    return timeoutId;
  };

  // 清除所有定时器
  const clearAllTimers = () => {
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  useEffect(() => {
    let viewData = [];
    // 设置输出数据
    if (id === 'gstep_first_box') {
      viewData = [...(contentSegments.slice(0, 4) || []), '...'];
    } else if (id === 'gstep_sec_box') {
      viewData = contentSegments || [];
      viewData.push(`${wordText} — ${wordNum} ${t("words")}`);
    } else if (id === 'gstep_third_box') {
      viewData = contentSegments || [];
    } else if (id === 'gstep_fourth_box') {
      viewData = contentSegments || [];
    }
    setViewTextArray(viewData);

    const revealNext = () => {
      currentIndexRef.current += 1;
      setVisibleIndexes(prev => {
        if (prev.includes(currentIndexRef.current)) return prev; // 避免重复
        return [...prev, currentIndexRef.current];
      });

      if (currentIndexRef.current < viewData.length) {
        const delay = 1000 + Math.floor(Math.random() * 200);
        safeSetTimeout(revealNext, delay);
      } else {
        clearAllTimers();
        onEnd && onEnd(id);
      }
    };
    if ((currentIndexRef.current < viewData.length)) {
      revealNext(); // 开始递进显示
    }

    return () => {
      clearAllTimers();
    }

  }, [id, contentSegments]);

  useEffect(() => {
    return () => clearAllTimers();
  }, []);

  return (
    <div id={id} className={`output-container ${customClass}`} style={{ maxHeight: maxHeightRef.current > 200 ? maxHeightRef.current : 200 }}>
      {viewTextArray.map((text, idx) => (
        <SinglePline
          index={idx}
          key={idx}
          id={id}
          text={text}
          visible={visibleIndexes.includes(idx + 1)}
        />
      ))}
    </div>
  );
};

// 单行段落
const SinglePline = React.memo(({ text, visible, id, index }) => {
  const Tag = ['gstep_first_box'].includes(id) ? 'li' : 'div';
  return <Tag className={`segment ${visible ? 'show' : ''} ${(id === 'gstep_sec_box' && index === 1) ? 'sec_nums' : ''}`}>{text}</Tag>;
});

export default AIOutputStream;
